<template>
    <div class="custom_homewor_level_list">
        <div class="homework_difficult flex Flexalign">
            <div class="line_green"></div>
            <div class="difficult_text ml-20">各项评级</div>
        </div>
        <div class="level_list">
            <div class="level_one mt-20" v-for="(item, index) in levelList" :key="index">
                <div class="level_name">{{ item.name }}</div>
                <div class="level_grade_list mt-15 flex Flexalign FlexBetween">
                    <div class="level_grade_list_one" v-for="(sitem, sindex) in item.gradeList" :key="sindex" :class="[item.value>=sitem.value?'level_grade_list_one_active':'']"></div>
                </div>
                <div class="level_grade_list mt-10 flex Flexalign FlexBetween">
                    <div class="level_grade_list_one_text" v-for="(sitem, sindex) in item.gradeList" :key="sindex">{{
                        sitem.label }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GjkcH5CustomHomeworLevelList',

    data() {
        return {
            levelList: []
        };
    },

    mounted() {

    },

    methods: {

    },
};
</script>

<style lang="scss" scoped>
.custom_homewor_level_list {
    width: 330px;
    background: #ffffff;
    border-radius: 10px;
    padding: 15px 20px;
    box-sizing: border-box;

    .homework_difficult {
        .line_green {
            width: 3px;
            height: 16px;
            background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
            border-radius: 4px;
        }

        .difficult_text {
            font-size: 18px;
            font-weight: 500;
            color: #111111;
        }
    }

    .level_list {
        .level_one {
            .level_name {
                font-size: 14px;
                color: #303030;
            }

            .level_grade_list {
                .level_grade_list_one {
                    width: 55px;
                    height: 8px;
                    background: #F7F8FA;
                }
                .level_grade_list_one_active{
                    background: linear-gradient( 97deg, #00D498 0%, #00D5C2 100%);
                }

                .level_grade_list_one_text {
                    width: 55px;
                    text-align: center;
                    font-size: 12px;
                    color: #909090;
                }
            }
        }
    }
}
</style>